"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestTrial = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _requestNotificationsApi = require("ui-addon-upgrades/_core/common/api/requestNotificationsApi");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var requestTrial = (0, _wrapWithErrorMonitoring.default)('requestTrial', function (_ref) {
  var merchandiseId = _ref.merchandiseId;
  return (0, _requestNotificationsApi.sendRequestTrialNotification)(merchandiseId).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request trial notification succeeded',
      merchandiseId: merchandiseId
    });
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request trial notification failed',
      merchandiseId: merchandiseId
    });

    _Raven.default.captureMessage('Request trial notification failed', {
      extra: {
        error: e
      }
    });

    throw e;
  });
});
exports.requestTrial = requestTrial;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/upgrade/requestTrial.js
// module id = 735
// module chunks = 5 6